import { render, staticRenderFns } from "./OnlineExhibition.vue?vue&type=template&id=2917f3a6"
import script from "./OnlineExhibition.vue?vue&type=script&lang=js"
export * from "./OnlineExhibition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports